/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button, Icon, Text } from '@chakra-ui/react';

/**
 *
 * @param {Object} item
 * @returns
 */
const AdComponent = ({ item }) => (
  <Box
    height={{ base: 'auto', md: '602px' }}
    py={{ base: '6rem', md: '10rem' }}
    width="100%"
    bg="black"
  >
    <Box
      letterSpacing={'0.32px'}
      fontFamily="var(--FedraSansStd-medium)"
      justifyContent={'center'}
      alignItems={'center'}
      display={'flex'}
      gap={{ base: '2.5rem' }}
      flexDirection={{ base: 'column' }}
    >
      <Text
        lineHeight={'160%'}
        color={'#F1EDE9'}
        fontSize={{ lg: '1.25rem', base: '1rem' }}
        width={{ md: '258px', base: '306px' }}
        textAlign={{ base: 'center' }}
      >
        {item.adText}
      </Text>
      {item.cta?.linkUrl && (
        <Button
          backgroundColor={'#60ADFF'}
          _hover={{
            bg: '#80BDFF', // Sets the background color on hover,
            textDecor: 'none',
          }}
          borderRadius={'none'}
          border={'none'}
          as={Link}
          h="50px"
          prefetch
          href={item.cta?.linkUrl}
        >
          <Text
            fontSize={{ base: '1rem' }}
            lineHeight={{ base: '1.6rem' }}
            color={'black'}
            display={'flex'}
            justifyItems="center"
            gap="5px"
            fontFamily="var(--FedraSansStd-book)"
          >
            {item.cta.buttonText}

            {item.cta.openInNewTab && (
              <Icon
                width="16px"
                mt={{ base: '.5rem', '2xl': '.3rem' }}
                height="16px"
                // viewBox="0 0 18px 18px"
                fill="none"
              >
                <path
                  d="M6 3H1V17H15V12M11 1H17M17 1V7M17 1L8 10"
                  stroke="#010509"
                  stroke-width="2"
                  strokeLinecap="square"
                />
              </Icon>
            )}
          </Text>
        </Button>
      )}
    </Box>
  </Box>
);

export default AdComponent;
